import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IBoxxGenericFormEmitter } from '@boxx/core';
import {
  CategoryModel,
  ProductModel,
  StorePageStore,
  VariationModel,
} from '@boxx/store-core';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxImageConstraints } from '@boxx/boxx-images/lib/models/BoxxImage.model';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { ImageDimensionsProps, ImageUtilsService } from 'src/services/ImageUtils.service';
import { BoxxImageDetailComponent } from '@boxx/boxx-images/lib/components/image-detail/image-detail.component';
import { VariantCreatorPage } from '@app/pages/store/components/products/variant-creator/variant-creator.page';
import { StockControlPage } from '@app/pages/store/components/categories/stock-control/stock-control.component';
import { ShippingControlPage } from '@app/pages/store/components/categories/shipping-control/shipping-control.component';

@Component({
  selector: 'boxx-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.scss'],
})
export class ProductFormComponent implements OnInit, OnDestroy, OnChanges {
  @Input() catId: string;
  @Input() subcatId: string;
  @Input() allowEdit: boolean;
  @Input() set product(product: ProductModel) {
    if (!this.productForm) {
      this.initForm();

      if (product && product.id) {
        this.myProduct = product;
        this.patchForm(this.myProduct);
      }
    }
    //this.initForm();
  }

  @Output() boxxChange = new EventEmitter<IStoreProductFormEmitter>();

  destroyed$ = new Subject<boolean>();

  slideOpts = {
    slidesPerView: 2.15,
    spaceBetween: 10,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
  };

  myProduct: ProductModel;

  productForm: FormGroup;
  hasOptions = false;
  productOptions: any[];

  totalImages = 0;
  productImages: any[] = [];
  // {
  //   [key: number]: { source: 'device' | 'web'; id: number; url: string };
  // } = {};
  selectedImages: { [key: number]: string } = {};

  categoryList: CategoryModel[] = [];
  subcategoryList: CategoryModel[] = [];
  hasSubcategory = false;
  loadingCategories = false;

  variationList: VariationModel[] = [];
  loadingVariations = false;

  readonly maxDimensions = { width: 3000, height: 3000 };

  private originalValues: ProductModel;

  private translations: any;
  /* private isIos = false;
  private isNative = false; */

  imageString: string;

  @Input() set maxLogoDimensions(payload: ImageDimensionsProps) {
    this.myMaxLogoDimensions = payload;
  }

  get maxLogoDimensions() {
    return this.myMaxLogoDimensions;
  } //{ width: 600, height: 300 };

  @Input() set maxMainDimensions(payload: ImageDimensionsProps) {
    this.myMaxMainDimensions = payload;
  }
  get maxMainDimensions() {
    return this.myMaxMainDimensions;
  } //{ width: 1749, height: 1849 };

  @Input() set maxGalleryDimensions(payload: ImageDimensionsProps) {
    this.myMaxGalleryDimensions = payload;
  }
  get maxGalleryDimensions() {
    return this.myMaxGalleryDimensions;
  } // { width: 500, height: 500 };

  @Input() set maxGalleryImages(value: number) {
    this.myMaxGalleryImages = value || this.DEFAULT_MAX_GALLERY_IMAGES;
  }

  get maxGalleryImages() {
    return this.myMaxGalleryImages;
  }

  readonly DEFAULT_MAX_GALLERY_IMAGES = 5;


  private myMaxLogoDimensions: ImageDimensionsProps = {
    width: 600,
    height: 300,
  };
  private myMaxMainDimensions: ImageDimensionsProps = {
    width: 1749,
    height: 1849,
  };
  private myMaxGalleryDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxGalleryImages = this.DEFAULT_MAX_GALLERY_IMAGES;

  constructor(
    private storePageStore: StorePageStore,
    private fb: FormBuilder,
    private viewCrtl: ModalController,
    private boxxUtils: BoxxUtilsService,
    private imageService: ImageUtilsService,
    translate: TranslateService,
    private alertCtrl: AlertController,
    private sanitizer: DomSanitizer,
    // platform: Platform
  ) {
    translate
      .get(['BUSINESS_FORMS', 'STORE_MODULE', 'IMAGES_MODULE', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));

    /* platform.ready().then(() => {
      this.isIos = platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));

      this.isNative = platform
        .platforms()
        .some((name) => ['cordova', 'capacitor'].includes(name));
    }); */
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allowEdit']) {
      console.log('allowEdit changed:', this.allowEdit);
    }
  }

  ngOnInit() {
    console.log('this.catId in form: ', this.catId);
    console.log('this.subcatId in form: ', this.subcatId);

    // if (this.catId !== null && this.catId !== undefined) {
    //   console.log('entro');
    //   this.productForm.patchValue({
    //     categories: this.catId
    //   });
    // }


    //this.loadVariations();
    this.handleLoading();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initForm() {
    this.productForm = this.fb.group({
      id: [''],
      product_images: [''],
      name: ['', Validators.required],
      description: [''],
      status: ['', Validators.required],
      statusText: [''],
      price: ['', Validators.required],
      compareToPrice: [''],
      sku: [''],
      categories: [],
      categoryName: [''],
      subcategory: [],
      subcategoryName: [''],
      options: [[]],
      unlimited: [true],
      weight: [''],
      length: [''],
      width: [''],
      dimensions: [''],
      height: [''],
      quantity: [0],
      published: [true],
      shipping_required: [false],
      galleryImages: [],
      imageList: []
    });
    this.originalValues = { ...this.productForm.value };
    this.loadCategories();
  }

  br2nl(html: string) {
    const stepOne = html.replace(/<br ?\/?>/g, "\n");
    const stepTwo = stepOne.replace(/<[^>]*>?/gm, '');
    const stepThree = stepTwo.replace(/(?:\ttrim|\r\n|\r|\t)/g, '');
    return stepThree;
  }

  patchForm(product: ProductModel) {
    //this.boxxUtils.handleLoading(true);
    console.log('product data previous: ', product);
    this.hasOptions = product.options.length > 0 ? true : false;
    this.productForm.patchValue({
      id: product.id,
      name: product.name,
      description: (product.description && product.description !== null) ? this.br2nl(product.description) : '',
      status: product.enabled ? 'available' : 'soldout',
      statusText: product.enabled ? this.translations.STORE_MODULE.productsItem_VIEW.available : this.translations.STORE_MODULE.productsItem_VIEW.notavailable,
      price: product.price,
      compareToPrice: product.compareToPrice,
      sku: product.sku,
      //categories: product.categoryIds ? product.categoryIds.map((c) => c) : [],
      options: product.options ? product.options.map((c) => c) : [],
      unlimited: (product.unlimited) ? product.unlimited : false,
      quantity: product.quantity,
      weight: product.weight,
      galleryImages: product.media.images ? product.media.images : [],
      imageList: product.media.images ? product.media.images : [],
      //published: product.published,
      shipping_required: false,
    });

    this.productOptions = product.options ? product.options.map((c) => c) : [];

    // this.totalImages = Object.values(product.productImages).length;

    if (product.media.images && product.media.images.length > 0) {
      product.media.images.forEach((image) => {
        this.productImages.push({
          id: image.id,
          idProduct: (this.myProduct) ? this.myProduct.id : 0,
          main: image.isMain,
          url: image.image800pxUrl,
          isNew: false,
        });
      });

      //setTimeout(() => {
        if(product.categoryIds.length > 0){
          let _cat = this.categoryList.find((c) => Number(c.id) === Number(product.categoryIds[0]));
          if(_cat){
            this.productForm.patchValue({
              categories: _cat.id,
              categoryName: _cat.name,
            });
          }
        }
        //this.boxxUtils.handleLoading(false);
      //}, 500);
      this.totalImages = product.media.images.length;
    }
    // this.productImages = product.media.images as any;
    // if (this.productImages.length > 0) {
    //   this.totalImages = 1;
    // }

    this.originalValues = { ...this.productForm.value };
    this.loadCategories();
  }

  async openStockPicker() {
    const _formData = this.productForm.value;
    const modal = await this.viewCrtl.create({
      component: StockControlPage,
      componentProps: {
        previousData: {
          unlimited: _formData.unlimited,
          quantity: _formData.quantity
        }
      },
    });

    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data?.value) {
      console.log('data: ', data.value);
      this.productForm.patchValue({
        unlimited: !data.value.addControl,
        quantity: (data.value.addControl) ? data.value.quantity : 0
      });
      this.onFieldChange();
    }
  }

  async openShippingPicker() {
    const _formData = this.productForm.value;
    const modal = await this.viewCrtl.create({
      component: ShippingControlPage,
      componentProps: {
        previousData: {
          //unlimited: _formData.unlimited,
          //quantity: _formData.quantity
        }
      },
    });

    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data?.value) {
      console.log('data: ', data.value);
      this.productForm.patchValue({
        shipping_required: data.value.addControl,
        weight: data.value.weight,
        length: data.value.length,
        width: data.value.width,
        height: data.value.height,
        dimensions: data.value.length + ' x ' + data.value.width + ' x ' + data.value.height
      });
      this.onFieldChange();
    }
  }

  async openVariantModal() {
    const modal = await this.viewCrtl.create({
      component: VariantCreatorPage,
      componentProps: {
        previousProductOptions: this.productOptions ? this.productOptions : [],
      },
    });

    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data) {
      this.productForm.patchValue({
        options: data,
      });
      this.hasOptions = true;

      this.productOptions = data;
      this.onFieldChange();
    }
  }

  confirmHideProduct(val: boolean) {
    if (!val || !this.myProduct) {
      return;
    }

    this.boxxUtils.showAlert({
      header:
        this.translations.STORE_MODULE.productsItem_VIEW.productForm
          .hideProduct,
      message:
        this.translations.STORE_MODULE.productsItem_VIEW.CONFIRM.hideMessage,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
          handler: () => {
            this.productForm.patchValue({
              published: false,
            });
          },
          cssClass: 'boxx-main-btn',
        },
        {
          text: this.translations.ACTIONS.hide,
        },
      ],
      backdropDismiss: false,
    });
  }

  getFirstImage() {
    if (this.productImages.length > 0) {
      return this.productImages[0]?.url;
    }
  }

  onFieldChange() {
    const values = this.productForm.value;

    const hasChanges = Object.keys(values).some((key) => {
      const originalValue = this.originalValues[key];
      const newValue = this.productForm.get(key).value;

      if (['categories', 'options'].includes(key)) {
        const valueHasChanges =
          newValue.length !== (originalValue || []).length ||
          !(originalValue || []).every((val: number) => newValue.includes(val));

        return valueHasChanges;
      }

      return newValue !== originalValue;
    });

    this.boxxChange.emit({
      hasChanges,
      data: values,
      valid: this.productForm.valid,
    });

  }

  async pickImagesForLogo() {
    const imageConstraints: BoxxImageConstraints = {
      maxWidth: 500,
      maxHeight: 500,
    };

    this.imageService.showImagePickerSources().then(
      async (data) => {
        switch (Number(data)) {
          case 1://Picker image browser
          case 2://Picker image device library
            await this.imageService.pickerFromDevice(imageConstraints, this.maxGalleryImages - this.totalImages).then(
              async (images) => {
                if (images && images.length > 0) {
                  images.forEach((image, idx) => {
                    this.productImages.push({
                      id: 0,
                      idProduct: (this.myProduct) ? this.myProduct.id : 0,
                      main: (this.productImages.length === 0) ? true : false,
                      url: image.content,
                      isNew: true,
                    });
                  });
                  this.totalImages = Object.keys(this.productImages).length;

                  this.productForm.patchValue({
                    imageList: this.productImages
                  });

                  this.onFieldChange();
                }
              });
            break;

          case 3://Pixabay
            await this.imageService.pickerFromPixaBay(imageConstraints, this.maxGalleryImages - this.totalImages).then(
              async (images) => {
                if (images && images.length > 0) {
                  images.forEach((image, idx) => {
                    this.productImages.push({
                      id: 0,
                      idProduct: (this.myProduct) ? this.myProduct.id : 0,
                      main: (this.productImages.length === 0) ? true : false,
                      url: image.content,
                      isNew: true,
                    });
                  });
                  this.totalImages = Object.keys(this.productImages).length;

                  this.productForm.patchValue({
                    imageList: this.productImages
                  });

                  this.onFieldChange();
                }
              });
            break;

          case 4://Camera
            await this.imageService.pickerFromCamera(imageConstraints).then(
              async (images) => {
                if (images && images.length > 0) {
                  images.forEach((image, idx) => {
                    this.productImages.push({
                      id: 0,
                      idProduct: (this.myProduct) ? this.myProduct.id : 0,
                      main: (this.productImages.length === 0) ? true : false,
                      url: image.content,
                      isNew: true,
                    });
                  });
                  this.totalImages = Object.keys(this.productImages).length;

                  this.productForm.patchValue({
                    imageList: this.productImages
                  });

                  this.onFieldChange();
                }
              });
            break;

          default:
            break;
        }
      }
    );
  }

  imageOptions(url: string, idx: number) {
    const buttons = [
      {
        key: 'view',
        value: 'BUSINESS_FORMS.WEBPAGE.LOGO_ACTIONS.detail',
        icon: 'eye-outline',
        icon_type: 'name',
        class: 'custom'
      },
      {
        key: 'delete',
        value: 'ACTIONS.delete',
        icon: 'refresh-outline',
        icon_type: 'name',
        class: 'custom'
      }
    ];


    this.boxxUtils.openBottomSheet({
      data: buttons,
      type: BottomSheetType.options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: buttons.length > 1 ? 30 : 20
    }).then(async (data) => {
      if (data?.value) {
        console.log('data?.value: ', data?.value);
        if (data?.value === 'view') {
          const view = await this.viewCrtl.create({
            component: BoxxImageDetailComponent,
            componentProps: {
              image: url,
              nameImage: ''
            },
          });

          view.present();
        }
        else if (data?.value === 'delete') {
          this.productImages.splice(idx, 1);
          this.totalImages--;
        }
      }
    });

  }

  private loadCategories() {
    this.storePageStore.categoriesStore.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((categoryList) => {
        this.categoryList = categoryList;
        setTimeout(() => {
          console.log('categoryList: ', categoryList);
          if (categoryList && categoryList.length > 0) {

            if (this.catId !== null && this.catId !== undefined) {
              let _cat = this.categoryList.find((c) => Number(c.id) === Number(this.catId));
              console.log('entro');
              let _cats: any[] = [];
              _cats.push(Number(this.catId));
              this.productForm.patchValue({
                categories: _cats,
                categoryName: _cat.name
              });
            }
            this.hasSubcategory = false;
            if ((this.subcatId !== null && this.subcatId !== undefined) && this.catId !== null && this.catId !== undefined) {
              this.subcategoryList = this.categoryList.filter((s) => Number(s.parentId) === Number(this.catId));
              if (this.subcategoryList.length > 0) {
                this.hasSubcategory = true;
                let _subcat = this.subcategoryList.find((c) => Number(c.id) === Number(this.subcatId));

                if (_subcat) {
                  let _subcats: any[] = [];
                  _subcats.push(Number(_subcat.id));
                  this.productForm.patchValue({
                    subcategory: _subcats,
                    subcategoryName: _subcat.name
                  });
                }
              }
            }
            // categories: [],
            // categoryName: [''],
            // subcategory: [],
            // subcategoryName: [''],
            // this.productForm.patchValue({
            //   categories: catId.toString()//  this.product.categories.map((c) => c.id),
            // });
          }
        }, 200);

      });

    this.storePageStore.categoriesStore.fetched$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((fetched) => {
        if (!fetched) {
          this.storePageStore.categoriesStore.fetch();
        }
      });
  }

  /*   private loadVariations() {
    this.storePageStore.data$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((variationList) => {
      this.variationList = variationList;

      if (variationList && this.myProduct && this.myProduct.variations) {
        this.productForm.controls.variations.patchValue(
          this.myProduct.variations.map((v) => v.id)
        );
        //this.cdr.detectChanges();
      }
    });

    this.storePageStore.fetched$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((fetched) => {
      if (!fetched) {
        this.storePageStore.loadVariations();
      }
    });
  } */

  private handleLoading() {
    this.storePageStore.categoriesStore.loading$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((loading) => {
        this.loadingCategories = loading;
        if (loading) {
          this.productForm.get('categories').disable();
        } else {
          this.productForm.get('categories').enable();
        }
      });
  }

  //Imágenes

  getSanitizedUrl(url: string) {
    if (typeof url !== 'string') {
      return;
    }

    if (
      !url ||
      !(
        url.startsWith('http') ||
        url.startsWith('file') ||
        url.startsWith('data')
      )
    ) {
      return 'assets/icon/images.svg';
    }

    url = url.replace('unsafe:', '');

    const response = url.startsWith('file')
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
        (window as any).Ionic.WebView.convertFileSrc(url)
      )
      : this.sanitizer.bypassSecurityTrustUrl(url);

    return (response as any).changingThisBreaksApplicationSecurity || response;
  }

  showImageInContainer(data: string[]) {
    //this.categoryForm.patchValue({ image: data[0] });
    this.onFieldChange();
    this.imageString = data[0];
  }

  removeImagefromList(prod, key) {
    this.alertCtrl
      .create({
        header: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.header,
        message: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.message,
        backdropDismiss: false,
        buttons: [
          {
            text: this.translations.ACTIONS.yes,
            role: 'destructive',
            handler: () => this.deleteImage(prod, key),
          },
          { text: this.translations.ACTIONS.no },
        ],
      })
      .then((a) => a.present());
  }

  async deleteImage(prod, key) {

    // this.productImages.splice(key, 1);
    // this.productForm.patchValue({
    //   imageList: this.productImages
    // });

    // this.totalImages = Object.keys(this.productImages).length;
    // this.onFieldChange();
    if (prod.url.toString().includes("data:image")) {
      this.productImages.splice(key, 1);
    }
    else {

      //Eliminar desde bd
      // this.productImages.splice(key, 1);
      // this.productForm.patchValue({
      //   imageList: this.productImages
      // });
      // this.totalImages = Object.keys(this.productImages).length;


      const index = this.productImages.indexOf(prod)

      const imageData = prod;//this.productImages[key];      
      const imageType = (imageData.main) ? 1 : 2;
      this.productImages.splice(index, 1);

      this.productForm.patchValue({
        imageList: this.productImages
      });
      this.onFieldChange();
      const imageDelete = {
        id: this.myProduct.id,
        type: imageType,
        index: imageData.id,
        imageList: {
          images: this.productImages
        }
      }

      this.storePageStore.productsStore.deleteProductImage(imageDelete);


      // if(){
      //   const
      //   this.storePageStore.productsStore.deleteProductImage(this.myProduct.id, );
      // }

      //this.confirmDeleteImage();
    }

  }

  openPickerCategory() {
    let dataTypes = [];

    for (let x = 0; x < this.categoryList.length; x++) {
      dataTypes.push({
        key: this.categoryList[x].id,
        value: this.categoryList[x].name,
        detail_two: this.categoryList[x].description,
        icon: 'grid-outline',
        icon_type: 'name',
        class: 'clean icon-default'
      });
    }

    this.boxxUtils.openBottomSheet({
      data: dataTypes,
      type: BottomSheetType.custom_options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 60
    }).then((data) => {
      console.log('data: ', data);
      if (data?.value) {
        let _cat = this.categoryList.find((c) => Number(c.id) === Number(data.value));
        this.subcategoryList = this.categoryList.filter((s) => Number(s.parentId) === Number(data.value));
        this.hasSubcategory = this.subcategoryList.length > 0 ? true : false;
        //if (!this.hasSubcategory) {
          this.productForm.patchValue({
            subcategory: [],
            subcategoryName: ''
          });
        //}
        console.log('_cat: ', _cat);
        console.log('_subcatscat: ', this.subcategoryList);
        let _cats: any[] = [];
        _cats.push(Number(data.value));
        this.productForm.patchValue({
          categories: _cats,
          categoryName: _cat.name
        });
        this.onFieldChange();
      }
    });
  }

  openPickerSubcategory() {
    let dataTypes = [];

    for (let x = 0; x < this.subcategoryList.length; x++) {
      dataTypes.push({
        key: this.subcategoryList[x].id,
        value: this.subcategoryList[x].name,
        detail_two: this.subcategoryList[x].description,
        icon: 'grid-outline',
        icon_type: 'name',
        class: 'clean icon-default'
      });
    }

    this.boxxUtils.openBottomSheet({
      data: dataTypes,
      type: BottomSheetType.custom_options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 60
    }).then((data) => {
      if (data?.value) {
        let _cat = this.subcategoryList.find((c) => Number(c.id) === Number(data.value));
        let _subcats: any[] = [];
        _subcats.push(Number(data.value));
        this.productForm.patchValue({
          subcategory: _subcats,
          subcategoryName: _cat.name
        });
        this.onFieldChange();
      }
    });
  }

  openStatusPicker() {

    let dataTypes = [
      {
        key: 'available',
        value: 'STORE_MODULE.productsItem_VIEW.available',
        icon: 'ellipse',
        icon_type: '',
        class: 'completed'
      },
      {
        key: 'soldout',
        value: 'STORE_MODULE.productsItem_VIEW.notavailable',
        icon: 'ellipse',
        icon_type: '',
        class: 'to-do'
      }
    ];

    this.boxxUtils.openBottomSheet({
      data: dataTypes,
      type: BottomSheetType.contact_type,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 30
    }).then(async (data) => {
      if (data?.value) {
        if (data?.value) {
          this.productForm.patchValue({
            status: data?.value,
            statusText: (data?.value === 'available') ? this.translations.STORE_MODULE.productsItem_VIEW.available : this.translations.STORE_MODULE.productsItem_VIEW.notavailable
          });
          this.onFieldChange();
        }
      }
    });
  }


}

export type IStoreProductFormEmitter = IBoxxGenericFormEmitter<any>;
